import { ReactNode } from 'react';
import { HeaderProvider } from '../contexts/HeaderContext';
import { MobileFilterProvider } from '../contexts/MobileFilterContext';
import { MobileSidebarProvider } from '../contexts/MobileSidebarContext';
import { useLayoutTier } from '../hooks/useLayoutTier';
import { EdmsProvisioning } from '../modules/app/EdmsProvisioning';
import { Header } from './Header';
import { Sidebar } from './Sidebar';
import TestModeBanner from './ui/TestModeBanner';

export interface AppLayoutProps {
  children: ReactNode;
}

export function AppLayout({ children }: AppLayoutProps) {
  const { isDesktopTier } = useLayoutTier();
  const isTestingMode = Boolean(import.meta.env.VITE_TEST_API_KEY);

  return (
    <MobileSidebarProvider>
      <MobileFilterProvider>
        <HeaderProvider>
          <div
            className='bg-white-support text flex h-dvh flex-col
              overflow-hidden'
          >
            <EdmsProvisioning />
            {isTestingMode && <TestModeBanner />}
            <Header />

            <div className='flex flex-1 overflow-hidden'>
              <Sidebar />
              <main
                className='bg-neutral-050 ml-0 flex min-w-0 flex-1
                  overflow-y-auto'
                style={{
                  marginLeft: isDesktopTier
                    ? 'var(--spacing-sidebar-width)'
                    : undefined,
                }}
              >
                {children}
              </main>
            </div>
          </div>
        </HeaderProvider>
      </MobileFilterProvider>
    </MobileSidebarProvider>
  );
}
